module.exports = __webpack_public_path__ + "static/media/MV-2.b54eca99.jpg";